import { AxiosPromise, AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { mapParcelCrudData, mapParcelData, mapTributeCrudData, mapTributeData } from './tributeClient.formatter';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const createParcel = ({ tributeId, payload }: { tributeId: number; payload: Tributes.ParcelCreate }): AxiosPromise<Tributes.Parcel> => {
  return request({
    options: {
      url: `${apiBaseUrl}/tribute/${tributeId}/create-parcel/`,
      method: 'POST',
      data: mapParcelCrudData(payload),
    },
  }).then((data: AxiosResponse<Tributes.ParcelApi>) => ({
    ...data,
    data: mapParcelData(data.data),
  }));
};

const createTribute = (payload: Tributes.Create): AxiosPromise<Tributes.Tribute> => {
  return request({
    options: {
      url: `${apiBaseUrl}/tribute/`,
      method: 'POST',
      data: mapTributeCrudData(payload),
    },
  }).then((data: AxiosResponse<Tributes.TributeApi>) => ({
    ...data,
    data: mapTributeData(data.data),
  }));
};

const getTribute = (params: { id: number | string }): AxiosPromise<Tributes.Tribute> => {
  return request({
    options: {
      url: `${apiBaseUrl}/tribute/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Tributes.TributeApi>) => ({
    ...data,
    data: mapTributeData(data.data),
  }));
};

const getMarketingTribute = (params: { id: number | string }): AxiosPromise<Tributes.Tribute> => {
  return request({
    options: {
      url: `${apiBaseUrl}/marketing-tributes/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Tributes.TributeApi>) => ({
    ...data,
    data: mapTributeData(data.data),
  }));
};


const editTribute = (payload: Tributes.Edit): AxiosPromise<Tributes.Tribute> => {
  return request({
    options: {
      url: `${apiBaseUrl}/tribute/${payload.id}/`,
      method: 'PUT',
      data: mapTributeCrudData(payload),
    },
  }).then((data: AxiosResponse<Tributes.TributeApi>) => ({
    ...data,
    data: mapTributeData(data.data),
  }));
};

const getTributes = (params?: Tributes.GetListParams): AxiosPromise<Tributes.Tribute[]> => {
  return request({
    options: {
      url: `${apiBaseUrl}/tribute/`,
      method: 'GET',
      params,
    },
  }).then((data: AxiosResponse<{ results: Tributes.TributeApi[] }>) => ({
    ...data,
    data: data.data.results.map(mapTributeData),
  }));
};

const payWithCredit = (tributeId: string): AxiosPromise => {
  return request({
    options: {
      url: `${apiBaseUrl}/tribute/${tributeId}/pay-with-credit/`,
      method: 'POST',
    },
  });
};

export const tributeClient = {
  createTribute,
  getTribute,
  getTributes,
  editTribute,
  createParcel,
  payWithCredit,
  getMarketingTribute,
};
